import { value } from "../helpers";
import { User } from "../pms-api/models";

middleware.$inject = [ 'MiddlewareServiceProvider' ];

/**
 * @param {MiddlewareServiceProvider} MiddlewareServiceProvider
 */
export default function middleware(MiddlewareServiceProvider) {

    MiddlewareServiceProvider.addNamed('user', user)
                             .addNamed('guest', guest)
                             .addNamed('user-with-role', userWithRole)
                             .addNamed('can', can)
                             .addNamed('can-by-roles', canByRoles);
}

/**
 * @param {AuthService} AuthService
 * @param {StateService} $state
 * @param {string|function():string} to
 * @returns {Promise.<User|TargetState>}
 */
function user(AuthService, $state, to = 'login') {
    
    return AuthService.user.catch(() => $state.target(value(to)));
}

user.$inject = [ 'AuthService', '$state' ];

/**
 * @param {AuthService} AuthService
 * @param {StateService} $state
 * @param {string|function(user:User):string} to
 * @returns {Promise.<User|TargetState>}
 */
function guest(AuthService, $state, to = 'dashboard') {

    return AuthService.user
                      .then((user) => $state.target(value(to, user)))
                      .catch(() => true);
}

guest.$inject = [ 'AuthService', '$state' ];

/**
 * @param {AuthService} AuthService
 * @param {StateService} $state
 * @param {string} role
 * @param {string|function(user:User):string} to
 * @returns {Promise.<User|TargetState>}
 */
function userWithRole(AuthService, $state, role, to = 'dashboard') {

    return user(AuthService, $state).then((result) => {

        if (result instanceof User && !result.hasBaseRole(role)) {

            result = $state.target(value(to, result));
        }

        return result;
    });
}

userWithRole.$inject = [ 'AuthService', '$state' ];

function can($state, AuthService, AclService, permission) {
    
    return user(AuthService, $state).then((result) => {
        
        if (!(result instanceof User)) {
            
            return $state.target('login');
        }
        
        if (!result.isSuperAdmin() && !AclService.can(permission)) {
            
            return $state.target('access-denied');
        }
        
        return true;
    });
}

can.$inject = [ '$state', 'AuthService', 'AclService' ];

function canByRoles($state, AuthService, AclService, rolePermission = {}) {

    return user(AuthService, $state).then(result => {

        if (!(result instanceof User)) {

            return $state.target('login');
        }

        const permission = rolePermission[result.role];

        if (!permission) {

            return true;
        }

        return can($state, AuthService, AclService, permission);
    });
}

canByRoles.$inject = [ '$state', 'AuthService', 'AclService' ];



// WEBPACK FOOTER //
// ./src/app-core/core.middleware.js